@if (documentNo) {
	<panel width="400">
		<h1>{{ 'invoice.set-on-hold.header' | translate }}</h1>
		<section>
			<custom-select [label]="'invoice.on-hold.reason' | translate" [selectList]="onHoldReasons" [(value)]="onHoldReason" />
		</section>
		<section>
			<button confirm (click)="updateStatus()" [ignoreValidation]="true" [active]="onHoldReason != undefined">{{ 'general.save' | translate }}</button>
		</section>
	</panel>
}
